import { Icon } from '@wk/components-v3-react16';
import CsbErrorBoundary from 'components/CsbErrorBoudary/CsbErrorBoundary';
import { Link } from 'react-router-dom';
import { Log } from '../../LogType';
import styles from './CellLogMessage.module.scss';

interface CellLogMessageProperties {
  data: Log;
  originalStartTime: string;
  rowIndex: number;
}

const buildStackTraceUrl = (
  data: Log,
  rowIndex: number,
  originalStartTime: string
) => {
  const searchParameters = new URLSearchParams({
    index: String(rowIndex),
    jobId: data.metadata?.CSBJobId || '',
    originalStartTime,
    stepName: data.metadata?.CSBWorkflowStepName || '',
    timestamp: data.timestamp,
  });
  return `/stack-trace?${searchParameters.toString()}`;
};

const CellLogMessage = ({
  data,
  rowIndex,
  originalStartTime,
}: CellLogMessageProperties) => {
  const noHasStackTrace = data.stackTrace === 'null' || !data.stackTrace;

  return (
    <CsbErrorBoundary>
      <div className={styles.cellContainer} data-testid="CellLogMessage">
        {!noHasStackTrace && (
          <Link
            to={buildStackTraceUrl(data, rowIndex, originalStartTime)}
            target="_blank"
            rel="noreferrer"
            className={styles.cellLink}
            data-testid="CellLogMessageLink"
          >
            <span>View Stack Trace Data</span>
            <Icon name="wk-icon-link-external" />
          </Link>
        )}
        {data.message && <span>{data.message}</span>}
      </div>
    </CsbErrorBoundary>
  );
};

export default CellLogMessage;
